import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { useStrings } from '../i18n/index.ts';
import { dismissPartnerPromo } from '../state/partner-promo.ts';
import { pushLayer } from '../state/router.ts';
import { Icon } from '../ui/icons.tsx';
import '../styles/cart.css';

const SITE = 'https://www.belgradewaterfront.com/en/';
const ASSETS = `${import.meta.env.BASE_URL}partner/`;

/**
 * Партнёрская вставка (демо): ролик марины Belgrade Waterfront во весь экран играет один раз
 * без звука, последний кадр остаётся до крестика или кнопки. Под роликом лежит его первый
 * кадр, поэтому экран не бывает чёрным; с «уменьшением движения» показывается только кадр.
 */
export function PartnerInterstitial() {
  const strings = useStrings();
  const release = useRef<(() => void) | null>(null);
  const reduceMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

  const close = () => {
    release.current?.();
    release.current = null;
    dismissPartnerPromo();
  };

  useEffect(() => {
    release.current = pushLayer(() => {
      release.current = null;
      dismissPartnerPromo();
    });
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      release.current?.();
      release.current = null;
    };
  }, []);

  return createPortal(
    <div className="partner" role="dialog" aria-modal="true" aria-label="Belgrade Waterfront">
      <img className="partner-media" src={`${ASSETS}partner-waterfront.jpg`} alt="" />
      {!reduceMotion && (
        <video className="partner-media" src={`${ASSETS}partner-marina.mp4`} poster={`${ASSETS}partner-waterfront.jpg`} autoPlay muted playsInline preload="auto" aria-hidden="true" />
      )}
      <div className="partner-shade" />
      <div className="partner-top">
        <img src={`${ASSETS}bw-logo.svg`} alt="Belgrade Waterfront" height={30} />
        <button type="button" className="partner-close" aria-label={strings.close} onClick={close}>
          <Icon name="close" size={16} weight={2.8} />
        </button>
      </div>
      <div className="partner-bottom">
        <p>{strings.partnerPromoSubtitle}</p>
        <a className="partner-cta" href={SITE} target="_blank" rel="noreferrer" onClick={close}>
          {strings.partnerPromoCta}
        </a>
      </div>
    </div>,
    document.body,
  );
}
